export const handleDownloadCSV = (csvText: string, fileName: string) => {
    const csv = csvText || '';
    const blob = new Blob([csv], { type: 'text/csv' });
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = fileName;
    a.click();
    window.URL.revokeObjectURL(url);
};

export const copyToClipboard = (text: string) => {
    navigator.clipboard.writeText(text);
}